import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay, startWith } from 'rxjs';
import { Params } from '@angular/router';
import { apis } from '../config/api';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class ActivitiesService {
  http = inject(HttpClient);
  url = apis.activities;

  getActivities(params: Params): Observable<any> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get(this.url, { params: httpParams });
  }

  getActivities$() {
    return this.getActivities({ limit: -1 }).pipe(
      map(({ activities }) => ({
        activities: Array.isArray(activities)
          ? activities.map((act: any) => ({
            value: act.id,
            label: act.name,
            id: act.id // duplicate for multiselect
          }))
          : [],
        loading: false,
        error: null
      })),
      startWith({
        activities: [],
        loading: true,
        error: null
      }),
      catchError(() =>
        of({
          activities: [],
          loading: false,
          error: 'Failed to load activities'
        })
      ),
      shareReplay(1)
    );

  }

  getBookedActivities(schoolId: string, params: Params): Observable<any> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get(`${this.url}/booked/${schoolId}`, { params: httpParams });
  }

  addActivity(body: Params): Observable<any> {
    return this.http.post(`${this.url}`, body);
  }

  updateActivity(params: Params): Observable<any> {
    const id = parseInt(params['id']);
    delete params['id'];
    return this.http.patch(`${this.url}/${id}`, params);
  }

  deleteActivity(id: number): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }
}
